import { Component, Input } from '@angular/core';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-landing-page-help-center',
    templateUrl: './landing-page-help-center.component.html',
    styleUrls: ['./landing-page-help-center.component.scss'],
    standalone: false
})
export class LandingPageHelpCenterComponent {
    @Input() id: string;
    @Input() header: string;
    @Input() description: string;
    @Input() externalUrl: string;
    @Input() linkText: string;
    readonly buttonTypesEnum = ButtonTypesEnum;

    constructor() {}
}
